import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import MaterialUiDivider from '@material-ui/core/Divider';
import { createStyles, Theme } from '@material-ui/core';

const styles = (theme: Theme) => createStyles({});

interface DividerAttributes {
    variant?: 'inset' | undefined;
    component?: any | undefined;
}

const Divider = (props: DividerAttributes) => {
    return (
        <MaterialUiDivider variant={props.variant ? props.variant : undefined} component={props.component ? props.component : undefined}/>
    );
}

Divider.muiName = "Divider";

export default withStyles(styles)(Divider);